import React from "react";
import {
  // Customizable Area Start
  Chip,
  Radio,
  styled,
  Select,
  MenuItem,
  Checkbox,
  Snackbar,
  TextField,
  FormGroup,
  MenuProps,
  FormControlLabel,
  Box,
  IconButton,
  Button
  // Customizable Area End
} from "@material-ui/core";

import {
  Add as AddIcon,
  Delete as DeleteIcon,
  CalendarToday as CalendarIcon
} from "@material-ui/icons";

import PromotionCreateController, {
  // Customizable Area Start
  IOption,
  configJSON,
  Props,
  S,
  usageTypes,
  statusTypes,
  itemTypes,
  offerItemTypes,
  offerTypes,
  daysOfWeek
  // Customizable Area End
} from "./PromotionCreateController.web";

// Customizable Area Start
import DateFnsUtils from "@date-io/moment";
import { Alert } from "@material-ui/lab";
import { DatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { CustomSearchableMultiSelect } from "../../../components/src/customComponent/CustomSearchableMultiSelect.web";
import moment from "moment";

const Strings = {
  pageTitle: "Promotion",
  create: "Create",
  edit: "Edit",
  save: "Save",
  add: "Add",
  cancel: "Cancel",
  promotionSaved: "Promotion saved successfully",
  somethingWentWrong: "Something went wrong",
  
  // Form Labels
  promotionName: "Promotion Name",
  promotionType: "Promotion Type",
  promoTextEn: "Promo Item Text (English)",
  promoTextAr: "Promo Item Text (Arabic)",
  discountNameEn: "Order Discount Name (English)",
  discountNameAr: "Order Discount Name (Arabic)",
  region: "Region",
  area: "Area",
  section: "Section",
  services: "Services",
  product: "Product",
  platform: "Platform",
  store: "Store",
  usageType: "Usage Type",
  noOfOrders: "Number of Orders",
  startDate: "Start Date",
  endDate: "End Date",
  status: "Status",
  minOrderAmount: "Minimum Order Amount",
  minItems: "Minimum Items",
  
  // Dynamic Sections
  promotionItems: "Promotion Items",
  promotionOfferItems: "Promotion Offer Items",
  excludedDays: "Excluded Days",
  excludedDates: "Excluded Dates",
  excludedTimes: "Excluded Times",
  
  // Placeholders
  enterPromotionName: "Enter promotion name",
  selectPromotionType: "Select promotion type",
  enterPromoText: "Enter promotional text",
  enterDiscountName: "Enter discount name",
  selectRegion: "Select Region",
  selectArea: "Select Area",
  selectSection: "Select Section",
  selectServices: "Select Services",
  selectProduct: "Select Product",
  selectPlatform: "Select Platform",
  selectStore: "Select Store",
  selectUsageType: "Select usage type",
  enterNoOfOrders: "Enter number of orders",
  selectStatus: "Select status",
  enterAmount: "Enter amount",
  enterItems: "Enter minimum items",
  selectDays: "Select days",
  selectDate: "Select date",
  enterReason: "Enter reason",
  selectStartTime: "Select start time",
  selectEndTime: "Select end time"
};
// Customizable Area End

class PromotionCreate extends PromotionCreateController {
  constructor(props: Props) {
    super(props);
  }

  // Customizable Area Start
  renderPromotionItems = () => {
    const { data, productListItemsDropdown, error } = this.state;
    const promotionItems = data.attributes.promotion_items.filter(item => !item._destroy);

    return (
      <DynamicSection>
        <SectionHeader>
          <TextLabel>{Strings.promotionItems} *</TextLabel>
        </SectionHeader>
        {promotionItems.map((item, index) => (
          <DynamicItemRow key={index}>
            <Select
              value={item.item_type}
              onChange={(e) => this.updatePromotionItem(index, "item_type", e.target.value)}
              variant="outlined"
              fullWidth
              style={{ marginRight: 8 }}
            >
              {itemTypes.map(type => (
                <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
              ))}
            </Select>
            {item.item_type !== "all_products" && (
            <AutocompleteSelect
              fieldName={`product_${index}`}
              placeholder={this.state.sectionSelectedData.length === 0 && !this.state.isSectionSelectAll ? "Select Section First" : "Select Product"}
              options={this.state.promotionItemProductListDropdown}
              value={item.catalogue_id}
              onChange={(_event: React.ChangeEvent, value: any) => {
                this.updatePromotionItem(index, "catalogue_id", value?.id || null);
              }}
              handleScroll={() => this.handlePromotionItemProductScroll(item.item_type)}
              isDisabled={this.state.sectionSelectedData.length === 0 && !this.state.isSectionSelectAll}
            />
            )}
            {promotionItems.length > 1 && (
              <IconButton 
                size="small"
                onClick={() => this.removePromotionItem(index)}
                style={{ color: "#EC4E20" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </DynamicItemRow>
        ))}
        {error.promotion_items && (
          <ErrorLabel>{error.promotion_items}</ErrorLabel>
        )}
      </DynamicSection>
    );
  };

  renderPromotionOfferItems = () => {
    const { data, productListItemsDropdown, error } = this.state;
    const offerItems = data.attributes.promotion_offer_items.filter(item => !item._destroy);

    return (
      <DynamicSection>
        <SectionHeader>
          <TextLabel>{Strings.promotionOfferItems} *</TextLabel>
        </SectionHeader>
        {offerItems.map((item, index) => (
          <DynamicItemRow key={index}>
            <Select
              value={item.offer_type}
              onChange={(e) => this.updatePromotionOfferItem(index, "offer_type", e.target.value)}
              variant="outlined"
              fullWidth
              style={{ marginRight: 8 }}
            >
              {this.getDynamicOfferTypes().map(type => (
                <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
              ))}
            </Select>
            {item.offer_type !== "same_item" && item.offer_type !== "all_products" && (
              <>
                <Select
                  value={item.item_type || "single_product"}
                  onChange={(e) => this.updatePromotionOfferItem(index, "item_type", e.target.value)}
                  variant="outlined"
                  fullWidth
                  style={{ margin: "0 8px" }}
                >
                  {offerItemTypes.map(type => (
                    <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                  ))}
                </Select>
                <AutocompleteSelect
                  fieldName={`offer_product_${index}`}
                  placeholder={this.state.sectionSelectedData.length === 0 && !this.state.isSectionSelectAll ? "Select Section First" : "Select Product"}
                  options={this.state.offerItemProductListDropdown}
                  value={item.catalogue_id || null}
                  onChange={(_event: React.ChangeEvent, value: any) => {
                    this.updatePromotionOfferItem(index, "catalogue_id", value?.id || null);
                  }}
                  handleScroll={() => this.handleOfferItemProductScroll(item.item_type || "single_product")}
                  isDisabled={this.state.sectionSelectedData.length === 0 && !this.state.isSectionSelectAll}
                />
              </>
            )}
            {offerItems.length > 1 && (
              <IconButton 
                size="small"
                onClick={() => this.removePromotionOfferItem(index)}
                style={{ color: "#EC4E20" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </DynamicItemRow>
        ))}
        {error.promotion_offer_items && (
          <ErrorLabel>{error.promotion_offer_items}</ErrorLabel>
        )}
      </DynamicSection>
    );
  };

  renderExcludedDates = () => {
    const { data, error } = this.state;
    const excludedDates = data.attributes.excluded_dates.filter(item => !item._destroy);

    return (
      <DynamicSection>
        <SectionHeader>
          <TextLabel>{Strings.excludedDates}</TextLabel>
          <IconButton 
            size="small"
            onClick={this.addExcludedDate}
            style={{ color: "#204B9C" }}
          >
            <AddIcon />
          </IconButton>
        </SectionHeader>
        {excludedDates.map((item, index) => (
          <DynamicItemRow key={index}>
            <DatePicker
              value={item.excluded_date}
              onChange={(date) => this.updateExcludedDate(index, "excluded_date", date)}
              format="DD/MM/YYYY"
              placeholder={Strings.selectDate}
              fullWidth
              inputVariant="outlined"
              style={{ marginRight: 8 }}
            />
            <StyledTextField
              value={item.reason}
              onChange={(e) => this.updateExcludedDate(index, "reason", e.target.value)}
              placeholder={Strings.enterReason}
              variant="outlined"
              fullWidth
            />
            {excludedDates.length > 1 && (
              <IconButton 
                size="small"
                onClick={() => this.removeExcludedDate(index)}
                style={{ color: "#EC4E20" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </DynamicItemRow>
        ))}
        {error.excluded_dates && (
          <ErrorLabel>{error.excluded_dates}</ErrorLabel>
        )}
      </DynamicSection>
    );
  };

  renderExcludedTimes = () => {
    const { data, error } = this.state;
    const excludedTimes = data.attributes.excluded_times.filter(item => !item._destroy);

    return (
      <DynamicSection>
        <SectionHeader>
          <TextLabel>{Strings.excludedTimes}</TextLabel>
          <IconButton 
            size="small"
            onClick={this.addExcludedTime}
            style={{ color: "#204B9C" }}
          >
            <AddIcon />
          </IconButton>
        </SectionHeader>
        {excludedTimes.map((item, index) => (
          <DynamicItemRow key={index}>
            <TextField
              type="time"
              value={item.start_time}
              onChange={(e) => this.updateExcludedTime(index, "start_time", e.target.value)}
              variant="outlined"
              fullWidth
              style={{ marginRight: 8 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
            />
            <TextField
              type="time"
              value={item.end_time}
              onChange={(e) => this.updateExcludedTime(index, "end_time", e.target.value)}
              variant="outlined"
              fullWidth
              style={{ marginRight: 8 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
            />
            {excludedTimes.length > 1 && (
              <IconButton 
                size="small"
                onClick={() => this.removeExcludedTime(index)}
                style={{ color: "#EC4E20" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </DynamicItemRow>
        ))}
        {error.excluded_times && (
          <ErrorLabel>{error.excluded_times}</ErrorLabel>
        )}
      </DynamicSection>
    );
  };
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      data,
      error,
      isLoading,
      isSaveLoader,
      noData,
      saveStatus,
      promotionTypes,
      regionList,
      areaList,
      sectionList,
      serviceList,
      productList,
      platformList,
      storeList,
      selectedRegions,
      selectedAreas,
      selectedSections,
      selectedServices,
      selectedPlatforms,
      selectedPlatform,
      platformSelectedOptionForList,
      selectedStores,
      selectedStoresForList,
      showEndDate,
      regionSelectedData,
      selectedRegionsForList,
      areaSelectedData,
      selectedAreasForList,
      sectionSelectedData,
      selectedSectionsForList,
      sectionLists,
      selectedServicesForList,
      serviceOptions,
      productListItemsDropdown,
      isSectionSelectAll,
      excludeDayList
    } = this.state;

    const {
      promotion_name,
      promotion_type_id,
      promo_item_text_en,
      promo_item_text_ar,
      order_discount_name_en,
      order_discount_name_ar,
      used,
      no_of_orders,
      minimum_order_amount,
      minimum_items,
      start_date,
      end_date,
      status,
      excluded_days
    } = data.attributes;
    // Customizable Area End

    return (
      // Customizable Area Start
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MainContainer>
            <Snackbar
              open={saveStatus.length > 0}
              autoHideDuration={5000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={() => this.setState({ saveStatus: "" })}
                severity={
                  saveStatus === Strings.promotionSaved ? "success" : "error"
                }
              >
                {saveStatus}
              </Alert>
            </Snackbar>
            
            <Heading>
              {this.isEdit ? Strings.edit : Strings.create} {Strings.pageTitle}
            </Heading>
            
            {isSaveLoader && <CustomLoader loading={isSaveLoader} />}
            
            {isLoading && !noData && <LoadingComponent>Loading...</LoadingComponent>}
            
            {!isLoading && noData && (
              <ErrorLabel>{Strings.somethingWentWrong}</ErrorLabel>
            )}
            
            {!isLoading && !noData && (
              <>
                <WhiteContainer>
                  <GridContainer>
                    <div>
                      <TextLabel>{Strings.promotionName} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={promotion_name}
                        variant="outlined"
                        placeholder={Strings.enterPromotionName}
                        onChange={(e) =>
                          this.onChangeValue("promotion_name", e.target.value)
                        }
                      />
                      {error.promotion_name && (
                        <ErrorLabel>{error.promotion_name}</ErrorLabel>
                      )}
                    </div>
                    
                    <div>
                      <TextLabel>{Strings.promotionType} *</TextLabel>
                      <AutocompleteSelect
                        fieldName="promotion_type"
                        placeholder={Strings.selectPromotionType}
                        options={promotionTypes.map(pt => ({ id: pt.id, option: pt.name || pt.label || '' }))}
                        value={promotion_type_id}
                        disableClear={true}
                        onChange={(_event: React.ChangeEvent, value: any) => {
                          this.onChangeValue("promotion_type_id", value?.id || null);
                        }}
                      />
                      {error.promotion_type_id && (
                        <ErrorLabel>{error.promotion_type_id}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.promoTextEn} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        multiline
                        rows={2}
                        value={promo_item_text_en}
                        variant="outlined"
                        placeholder={Strings.enterPromoText}
                        onChange={(e) =>
                          this.onChangeValue("promo_item_text_en", e.target.value)
                        }
                      />
                      {error.promo_item_text_en && (
                        <ErrorLabel>{error.promo_item_text_en}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.promoTextAr} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        multiline
                        rows={2}
                        value={promo_item_text_ar}
                        variant="outlined"
                        placeholder={Strings.enterPromoText}
                        onChange={(e) =>
                          this.onChangeValue("promo_item_text_ar", e.target.value)
                        }
                      />
                      {error.promo_item_text_ar && (
                        <ErrorLabel>{error.promo_item_text_ar}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.discountNameEn} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={order_discount_name_en}
                        variant="outlined"
                        placeholder={Strings.enterDiscountName}
                        onChange={(e) =>
                          this.onChangeValue("order_discount_name_en", e.target.value)
                        }
                      />
                      {error.order_discount_name_en && (
                        <ErrorLabel>{error.order_discount_name_en}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.discountNameAr} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={order_discount_name_ar}
                        variant="outlined"
                        placeholder={Strings.enterDiscountName}
                        onChange={(e) =>
                          this.onChangeValue("order_discount_name_ar", e.target.value)
                        }
                      />
                      {error.order_discount_name_ar && (
                        <ErrorLabel>{error.order_discount_name_ar}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.region} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id="region"
                        name="region"
                        dataTestId="regionDropdown"
                        checkSelectAllText={() => {}}
                        value={regionSelectedData}
                        optionList={regionList.map(r => ({ id: r.id, option: r.name }))}
                        placeHolderText={Strings.selectRegion}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleRegionMultiSelect(values, option);
                        }}
                        emptyDataMessage="No Region Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedRegionsForList}
                        isError={Boolean(error.region_ids)}
                      />
                      {error.region_ids && <ErrorLabel>{error.region_ids}</ErrorLabel>}
                    </div>

                    <div>
                      <TextLabel>{Strings.area} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id="area"
                        name="area"
                        dataTestId="areaDropdown"
                        checkSelectAllText={() => {}}
                        value={areaSelectedData}
                        optionList={areaList.map(a => ({ id: a.id, option: a.name }))}
                        placeHolderText={Strings.selectArea}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleAreaMultiSelect(values, option);
                        }}
                        emptyDataMessage="No Area Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedAreasForList}
                        isError={Boolean(error.area_ids)}
                      />
                      {error.area_ids && <ErrorLabel>{error.area_ids}</ErrorLabel>}
                    </div>

                    <div>
                      <TextLabel>{Strings.section} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id="section"
                        name="section"
                        dataTestId="sectionDropdown"
                        checkSelectAllText={() => {}}
                        value={sectionSelectedData}
                        optionList={sectionLists}
                        placeHolderText={Strings.selectSection}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleSectionMultiSelect(values, option);
                        }}
                        emptyDataMessage="No Section Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedSectionsForList}
                        isError={Boolean(error.section_ids)}
                      />
                      {error.section_ids && <ErrorLabel>{error.section_ids}</ErrorLabel>}
                    </div>

                    <div>
                      <TextLabel>{Strings.services} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id="services"
                        name="services"
                        dataTestId="servicesDropdown"
                        checkSelectAllText={() => {}}
                        value={selectedServices}
                        optionList={serviceOptions}
                        placeHolderText={Strings.selectServices}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleSelectServiceOptions(values, option);
                        }}
                        emptyDataMessage="No Services Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedServicesForList}
                        isError={Boolean(error.service_ids)}
                      />
                      {error.service_ids && <ErrorLabel>{error.service_ids}</ErrorLabel>}
                    </div>


                    <div>
                      <TextLabel>{Strings.platform} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id="platform"
                        name="platform"
                        dataTestId="platformDropdown"
                        checkSelectAllText={() => {}}
                        value={selectedPlatform}
                        optionList={platformList.map(p => ({ id: p.id, option: p.option || p.name || p.label || '' }))}
                        placeHolderText={Strings.selectPlatform}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: IOption[], option: IOption) => {
                          const convertedValues = values.map(v => ({ id: v.id.toString(), option: v.option || v.name || '' }));
                          const convertedOption = { id: option.id.toString(), option: option.option || option.name || '' };
                          this.handlePlatformMultiSelect(convertedValues, convertedOption);
                        }}
                        emptyDataMessage="No Platforms Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={platformSelectedOptionForList}
                        isError={Boolean(error.platform_ids)}
                      />
                      {error.platform_ids && <ErrorLabel>{error.platform_ids}</ErrorLabel>}
                    </div>

                    {selectedPlatforms.find((p: IOption) => p.id === 1 || p.id === "1") && (
                      <div>
                        <TextLabel>{Strings.store}</TextLabel>
                        <CustomSearchableMultiSelect
                          id="store"
                          name="store"
                          dataTestId="storeDropdown"
                          checkSelectAllText={() => {}}
                          value={selectedStoresForList}
                          optionList={storeList.map(s => ({ id: s.id, option: s.store_name || s.name || s.label || '' }))}
                          placeHolderText={Strings.selectStore}
                          changeInputOnClear
                          handleScroll={() => {}}
                          handleClickOnSelectAll={() => {}}
                          isOnBlurFunction={() => {}}
                          debouncedFunction={(getValue: string) => {}}
                          handleSelectOptions={(values: IOption[], option: IOption) => {
                            const convertedValues = values.map(v => ({ id: v.id.toString(), option: v.option || v.name || '' }));
                            const convertedOption = { id: option.id.toString(), option: option.option || option.name || '' };
                            this.handleStoreMultiSelect(convertedValues, convertedOption);
                          }}
                          emptyDataMessage="No Stores Found"
                          handleEmptyAutoSelectValue={() => {}}
                          selectedOptionForList={selectedStoresForList}
                          isError={Boolean(error.store_ids)}
                        />
                        {error.store_ids && <ErrorLabel>{error.store_ids}</ErrorLabel>}
                      </div>
                    )}

                    <div>
                      <TextLabel>{Strings.usageType}</TextLabel>
                      <AutocompleteSelect
                        fieldName="usage_type"
                        placeholder={Strings.selectUsageType}
                        options={usageTypes.map(ut => ({ id: ut.id, option: ut.name }))}
                        value={used}
                        disableClear={true}
                        isRadioButtonShow={true}
                        onChange={(_event: React.ChangeEvent, value: any) => {
                          this.onChangeValue("used", value?.id || "all_orders");
                        }}
                      />
                      {error.used && <ErrorLabel>{error.used}</ErrorLabel>}
                    </div>

                    {used === "specific_number_of_orders" && (
                      <div>
                        <TextLabel>{Strings.noOfOrders}</TextLabel>
                        <StyledTextField
                          fullWidth
                          type="number"
                          value={no_of_orders || ""}
                          variant="outlined"
                          placeholder={Strings.enterNoOfOrders}
                          onChange={(e) => {
                            const value = e.target.value ? parseInt(e.target.value) : null;
                            this.onChangeValue("no_of_orders", value);
                          }}
                        />
                        {error.no_of_orders && (
                          <ErrorLabel>{error.no_of_orders}</ErrorLabel>
                        )}
                      </div>
                    )}

                    <div>
                      <TextLabel>{Strings.startDate} *</TextLabel>
                      <DatePicker
                        value={start_date}
                        onChange={(date) => this.onChangeValue("start_date", date)}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        fullWidth
                        inputVariant="outlined"
                        disablePast={!this.isEdit}
                      />
                      {error.start_date && (
                        <ErrorLabel>{error.start_date}</ErrorLabel>
                      )}
                      
                      <FormGroup row>
                        <FormControlLabel
                          checked={showEndDate}
                          control={
                            <Checkbox
                              onClick={() =>
                                this.setShowEndDate(!showEndDate)
                              }
                            />
                          }
                          label={
                            <LabelStyled
                              style={{
                                color: showEndDate ? "#204B9C" : "#4D4D4D",
                              }}
                            >
                              Has End Date
                            </LabelStyled>
                          }
                        />
                      </FormGroup>
                    </div>

                    {showEndDate && (
                      <div>
                        <TextLabel>{Strings.endDate}</TextLabel>
                        <DatePicker
                          value={end_date}
                          onChange={(date) => this.onChangeValue("end_date", date)}
                          format="DD/MM/YYYY"
                          placeholder="DD/MM/YYYY"
                          fullWidth
                          inputVariant="outlined"
                          disablePast={true}
                        />
                        {error.end_date && (
                          <ErrorLabel>{error.end_date}</ErrorLabel>
                        )}
                      </div>
                    )}

                    <div>
                      <TextLabel>{Strings.minOrderAmount}</TextLabel>
                      <StyledTextField
                        fullWidth
                        type="number"
                        value={minimum_order_amount}
                        variant="outlined"
                        placeholder={Strings.enterAmount}
                        onChange={(e) =>
                          this.onChangeValue("minimum_order_amount", e.target.value)
                        }
                      />
                      {error.minimum_order_amount && (
                        <ErrorLabel>{error.minimum_order_amount}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.minItems}</TextLabel>
                      <StyledTextField
                        fullWidth
                        type="number"
                        value={minimum_items}
                        variant="outlined"
                        placeholder={Strings.enterItems}
                        onChange={(e) => {
                          const value = e.target.value ? parseInt(e.target.value) : 1;
                          this.onChangeValue("minimum_items", value);
                        }}
                      />
                      {error.minimum_items && (
                        <ErrorLabel>{error.minimum_items}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.status} *</TextLabel>
                      <AutocompleteSelect
                        fieldName="status"
                        placeholder={Strings.selectStatus}
                        options={statusTypes.map(st => ({ id: st.id, option: st.name }))}
                        value={status}
                        disableClear={true}
                        isRadioButtonShow={true}
                        onChange={(_event: React.ChangeEvent, value: any) => {
                          this.onChangeValue("status", value?.id || "active");
                        }}
                      />
                      {error.status && <ErrorLabel>{error.status}</ErrorLabel>}
                    </div>

                    <div>
                      <TextLabel>{Strings.excludedDays}</TextLabel>
                      <CustomSearchableMultiSelect
                        id="excludedDays"
                        name="excludedDays"
                        dataTestId="excludedDaysDropdown"
                        checkSelectAllText={() => {}}
                        value={excluded_days.filter(d => !d._destroy).map(d => {
                          // Find the matching day from excludeDayList to get the correct id
                          const matchingDay = excludeDayList.find(day => day.option === d.day_of_week);
                          return {
                            id: matchingDay ? matchingDay.id : d.day_of_week,
                            name: d.day_of_week,
                            option: d.day_of_week
                          };
                        })}
                        optionList={excludeDayList.map(d => ({ id: d.id, option: d.option }))}
                        placeHolderText={Strings.selectDays}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: IOption[], option: IOption) => {
                          this.handleMultiSelectChange("excluded_days", values, option);
                        }}
                        emptyDataMessage="No Days Found"
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={excluded_days.filter(d => !d._destroy).map(d => {
                          // Find the matching day from excludeDayList to get the correct id
                          const matchingDay = excludeDayList.find(day => day.option === d.day_of_week);
                          return {
                            id: matchingDay ? matchingDay.id : d.day_of_week,
                            name: d.day_of_week,
                            option: d.day_of_week
                          };
                        })}
                        isError={Boolean(error.excluded_days)}
                      />
                      {error.excluded_days && <ErrorLabel>{error.excluded_days}</ErrorLabel>}
                    </div>
                  </GridContainer>

                  <br />
                  <GridContainer>
                    <LeftContainer>
                      {this.renderPromotionItems()}
                      {this.renderExcludedDates()}
                    </LeftContainer>
                    <div>
                      {this.renderPromotionOfferItems()}
                      {this.renderExcludedTimes()}
                    </div>
                  </GridContainer>
                </WhiteContainer>

                <BottomContainer>
                  <button
                    data-test-id="btn-cancel"
                    onClick={() => this.clickCancel()}
                    className="cancel"
                  >
                    {Strings.cancel}
                  </button>
                  <button
                    data-test-id="btn-submit"
                    className="add"
                    onClick={() => this.onSubmit()}
                  >
                    {this.isEdit ? Strings.save : Strings.add} {Strings.pageTitle}
                  </button>
                </BottomContainer>
              </>
            )}
            <br />
            <br />
          </MainContainer>
        </MuiPickersUtilsProvider>
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
export const ErrorLabel = styled("div")({
  fontSize: 14,
  marginTop: 6,
  fontWeight: 500,
  color: "#EC4E20",
  lineHeight: "22px",
  letterSpacing: "0.25px",
  fontFamily: "Montserrat",
});

const LoadingComponent = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
  fontSize: 16,
  color: "#204B9C",
});

export const LabelStyled = styled("span")({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
});

export const StyledTextField = styled(TextField)({
  borderRadius: 8,
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
  },
  "@media only screen and (max-width: 1024px)": {
    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "14.9px 14px",
    },
  },
});

export const TextLabel = styled("label")({
  display: "block",
  fontSize: 16,
  lineHeight: "24px",
  fontWeight: 600,
  paddingBottom: 4,
  color: "var(--neutrals-cool-gray-700, #334155)",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "13px",
  },
});

export const GridContainer = styled("div")({
  display: "grid",
  gridGap: 32,
  gridTemplateColumns: "1fr 1fr",
});

const LeftContainer = styled("div")({
  "& > div": {
    paddingBottom: 32,
  },
});

export const WhiteContainer = styled("div")({
  borderRadius: 12,
  background: "#FFF",
  padding: "24px 32px",
  boxShadow:
    "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
});

export const Heading = styled("h2")({
  color: "#000",
  fontSize: 24,
  fontWeight: 600,
  paddingBottom: 25,
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

export const BottomContainer = styled("div")({
  gap: 32,
  display: "flex",
  paddingTop: 48,
  "& > button": {
    fontSize: 16,
    padding: 16,
    minWidth: 126,
    border: "none",
    fontWeight: 700,
    borderRadius: 8,
    cursor: "pointer",
    lineHeight: "24px",
    alignItems: "center",
    display: "inline-flex",
    justifyContent: "center",
    fontFamily: "Montserrat",
    "&:disabled": {
      opacity: 0.5,
    },
  },
  "& > .add": {
    color: "white",
    background: "var(--primary, #204B9C)",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
  "& > .cancel": {
    color: "#64748B",
    background: "var(--primary, #F1F5F9)",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
});

export const MainContainer = styled(Box)({
  paddingTop: "25px",
});

const DynamicSection = styled("div")({
  marginBottom: 24,
});

const SectionHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 12,
});

const DynamicItemRow = styled("div")({
  display: "flex",
  alignItems: "center",
  marginBottom: 12,
  gap: 8,
});

// Customizable Area End

export default PromotionCreate;